export default "/images/cat-youtube2.png?beceeb9c8a03acd93a35a95b9b792d82";